<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">إدخال ملف فيديو</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "videoalbumForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="titleAr"
                                [tooltip]="fc.titleAr.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.titleAr.valid && (fc.titleAr.touched)"
                                [class.is-invalid]="fc.titleAr.invalid && (fc.titleAr.touched)"
                                
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>

                            <!-- <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div> -->
                            <!-- order  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الترتيب</label>
                                <input class="form-control" id="validation01" type="text" formControlName="order"
                                [tooltip]="fc.order.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.order.valid && (fc.order.touched)"
                                [class.is-invalid]="fc.order.invalid && (fc.order.touched)"
                                onlyNumbers
                                     required
                                     placeholder="الترتيب"
                                    containerClass="" />
                            </div>
                          
                            <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                                <label for="">المحافظة</label>
                                <div class="form-group">
                                    <ng-multiselect-dropdown
                                    formControlName="GovernatesIds"
                                    [placeholder]="'اختر المحافظة  '"
                                    [settings]="dropdownSettings"
                                    [data]="Governates"
                                    [(ngModel)]="selectedItemsGovernates">
                                              </ng-multiselect-dropdown>
                                </div>
                              </div> 
                             
                        
                        </div>
                        <!-- insert image -->
                                 
                         <!-- to insert image  -->
                         <div class="col-6 my-3 " >
                            <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                           <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                            style="display: none" (change)="getLogoUrl($event)" />
                        <button type="button" onclick="document.getElementById('getLogo').click()"
                            class="btn   d-block"  style="width: 60%;">
                            ارفاق صورة
                        </button>    
                                    </div>
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

